import(/* webpackMode: "eager", webpackExports: ["HomeClientContent"] */ "/home/nexts/lm-master-front/src/flat-pages/home/index.tsx");
